export const clinicalStageLabels = {
  "pre_clin": "Preclinical/NC study",
  "clin_stage_1": "Ph.1 trial",
  "clin_stage_2": "Ph.2 trial",
  "clin_stage_3": "Ph.3 trial",
  "clin_stage_4": "Post-approval trial"
};
